import dayjs from 'dayjs'
import { useTrackMutation } from '@mote/api'
import {
  CHECKOUT_EXTENSION_REDIRECT_URL,
  TRACK_EVENT_NAMES
} from '@mote/helpers/constants'
import { Block, Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export interface QuotaExceededErrorProps {
  onClose: () => void
  nextFreeBatchDate: number
  isMinor: boolean
}

export function QuotaExceededError(
  props: QuotaExceededErrorProps
): JSX.Element {
  const dayJsDate = dayjs(props.nextFreeBatchDate * 1000)
  const dateToDays = dayJsDate.diff(new Date(), 'day')
  const trackMutation = useTrackMutation()

  function handleUpgrade() {
    trackMutation.mutate({
      variables: { event: TRACK_EVENT_NAMES.quota.clickedUpgrade }
    })
    window.open(CHECKOUT_EXTENSION_REDIRECT_URL, '_blank')
  }

  return (
    <GenericRecorderErrorsTemplate
      onClose={props.onClose}
      header={
        <>
          You are out of free motes!{' '}
          <Text tag={'small'} fontSize={17}>
            😭
          </Text>
        </>
      }
      content={
        <Block gap={16}>
          <Text fontWeight={400} fontSize={15} lineHeight='120%'>
            You'll get 20 more in {dateToDays} day{dateToDays > 1 ? 's' : ''}.
          </Text>
          <Text fontWeight={400} fontSize={15} lineHeight='120%'>
            {props.isMinor
              ? 'Why wait? Ask an adult to upgrade you to Unlimited to keep moting!'
              : 'Why wait? Upgrade to Unlimited or refer a friend to keep moting! '}
            <Text fontSize={15} tag={'small'}>
              🎉
            </Text>
          </Text>
        </Block>
      }
      buttons={
        <>
          <Button
            variant='secondary'
            text='Dismiss'
            onClick={props.onClose}
            autoWidth
          />
          <Button
            variant='primary'
            text='Upgrade'
            onClick={handleUpgrade}
            autoWidth
          />
        </>
      }
    />
  )
}
